/* Lazy header menu: the dropdown contents (department bar panels, All Departments
   panes, phone drawer category lists) are not in the page HTML. Every placeholder
   [data-lazy-menu] has a stable id; the hidden page /pages/menu-data renders the
   same header in full, fetched once through the Section Rendering API on the first
   hover / focus / tap of the header, or when the browser is idle. Department names
   and "Shop all" links are always server-rendered. Vanilla JS, no dependencies. */
(function () {
  if (window.__lazyMenuLoaded) return;
  window.__lazyMenuLoaded = true;

  var script = document.currentScript || document.querySelector('script[data-lazy-menu-src]');
  if (!script) return;
  var src = script.getAttribute('data-lazy-menu-src');
  var sectionId = script.getAttribute('data-lazy-menu-section');
  var idleMs = parseInt(script.getAttribute('data-lazy-menu-idle'), 10) || 2000;
  if (!src || !sectionId) return;

  var themeId = window.Shopify && window.Shopify.theme ? window.Shopify.theme.id : '';
  var cacheKey = 'lazy-menu:' + themeId + ':' + sectionId;
  var pending = null;
  var done = false;

  function holes() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-lazy-menu]'));
  }

  function fill(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var filled = 0;
    holes().forEach(function (hole) {
      var full = doc.getElementById(hole.id);
      if (!full) return;
      hole.innerHTML = full.innerHTML;
      hole.removeAttribute('data-lazy-menu');
      hole.removeAttribute('aria-busy');
      filled += 1;
    });
    done = true;
    document.dispatchEvent(new CustomEvent('lazy-menu:loaded', { detail: { filled: filled } }));
    return filled;
  }

  function load() {
    if (done || !holes().length) return Promise.resolve();
    if (pending) return pending;
    try {
      var cached = sessionStorage.getItem(cacheKey);
      if (cached && fill(cached) > 0) return Promise.resolve();
    } catch (e) { /* storage blocked: fetch */ }
    pending = fetch(src + '?sections=' + encodeURIComponent(sectionId), { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('menu ' + r.status);
        return r.json();
      })
      .then(function (json) {
        var html = json && json[sectionId];
        if (!html) throw new Error('menu: empty section');
        if (fill(html) > 0) {
          try { sessionStorage.setItem(cacheKey, html); } catch (e) { /* quota: fine */ }
        }
      })
      .catch(function () {
        pending = null; /* let the next interaction retry */
      });
    return pending;
  }

  /* first intent anywhere in the header (mouse, keyboard, touch) */
  var header = script.closest('.shopify-section') || document.querySelector('[id$="__header"]') || document;
  ['pointerenter', 'focusin', 'touchstart'].forEach(function (type) {
    header.addEventListener(type, load, { once: true, passive: true });
  });
  /* menus opened by code paths that skip the events above (sticky All Departments button, drawer toggle) */
  document.addEventListener('toggle', function (e) {
    var t = e.target;
    if (t && t.matches && t.matches('details') && t.hasAttribute('open')) load();
  }, true);
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[data-sticky-all-depts], .header__icon--menu, summary')) load();
  }, true);

  /* otherwise warm it in the background once the page has settled */
  function idle() {
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(load, { timeout: idleMs + 3000 });
    } else {
      load();
    }
  }
  if (document.readyState === 'complete') {
    setTimeout(idle, idleMs);
  } else {
    window.addEventListener('load', function () { setTimeout(idle, idleMs); }, { once: true });
  }
})();
